import {Box} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import AppShakingIconButton from 'components/buttons/AppShakingIconbutton';
import {AppDrawer} from 'components/drawers';
import {AppTooltip} from 'components/toolip';
import {Refresh} from 'iconsax-react';
import {useState} from 'react';
import {FcAlarmClock} from 'react-icons/fc';
import {HiPlus} from 'react-icons/hi';
import {useSelector} from 'react-redux';

import {AppEllipsisTypography} from 'components/typographies';
import {appDrawerSelector} from 'store/themeSettings';
import {timeTrackerSelector} from 'store/timeTracker';
import {DrawerTypeValue} from 'types';
import {TimeTrackerDarwaerContent} from './components';

export const TimeTrackerDrawer = () => {
    const {isConuterStarted, selectedTimeTrackInRedux} = useSelector(timeTrackerSelector);
    const {isRightDrawerOpened} = useSelector(appDrawerSelector);
    const [refreshState, setrefreshState] = useState<number>(0);
    const handleRefresh = (): void => {
        setrefreshState(prev => prev + 1);
    };
    const [openAddUpdateDialog, setOpenAddUpdateDialog] = useState(false);
    const handleOpenAddUpdateDialog = () => {
        setOpenAddUpdateDialog(true);
    };
    const handleCloseAddUpdateDialog = () => {
        setOpenAddUpdateDialog(false);
    };

    return (
        <>
            <AppDrawer
                drawerType={DrawerTypeValue.TimeTracker}
                nodeBeforeTitle={
                    <AppTooltip title="Add Manual Entry">
                        <AppIconButton color="primary" variant="outlined" onClick={handleOpenAddUpdateDialog}>
                            <HiPlus />
                        </AppIconButton>
                    </AppTooltip>
                }
                renderElement={(_open, handleOpen) => {
                    return (
                        <Box sx={{flexShrink: 0, ml: 0.75}}>
                            <AppTooltip title="Time Tracker" placement="left-start">
                                <AppShakingIconButton
                                    elevate={isRightDrawerOpened === DrawerTypeValue.TimeTracker}
                                    shouldShake={isConuterStarted}
                                    onClick={handleOpen}
                                >
                                    <FcAlarmClock />
                                </AppShakingIconButton>
                            </AppTooltip>
                        </Box>
                    );
                }}
                renderRightHeader={
                    <Box textAlign={'start'} display="flex" alignItems="center">
                        <AppEllipsisTypography
                            variant="h4"
                            maxLetters={25}
                            text={(selectedTimeTrackInRedux && selectedTimeTrackInRedux.title) ?? 'Timer'}
                        />
                        <AppTooltip title="Refresh">
                            <AppIconButton sx={{ml: 0.5}} size="small" onClick={handleRefresh}>
                                <Refresh size={1} />
                            </AppIconButton>
                        </AppTooltip>
                    </Box>
                }
                showHeaderButton
            >
                <TimeTrackerDarwaerContent
                    handleCloseAddUpdateDialog={handleCloseAddUpdateDialog}
                    openAddUpdateDialog={openAddUpdateDialog}
                    handleOpenAddUpdateDialog={handleOpenAddUpdateDialog}
                    key={'time-tracker-drawer-content-' + refreshState}
                />
            </AppDrawer>
        </>
    );
};

export default TimeTrackerDrawer;
